import { Component, Input, OnInit, EventEmitter, Output, ViewChild, OnDestroy } from '@angular/core';
import { DeliverySearch } from '../../models/delivery-search';
import { ComboDto } from '../../../../dtos/combo-dto';
import { ApiService } from '../../../../core/services/api.service';
import { ShipStatusEnum } from '../../../../enums/ship-status-enum';
import { ShipDetailEnum } from 'src/app/enums/ship-detail-enum';
import { FormControl } from '@angular/forms';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { MatSelect, VERSION } from '@angular/material';

@Component({
  selector: 'delivery-search',
  templateUrl: './delivery-search.component.html',
  styleUrls: ['./delivery-search.component.scss']
})
export class DeliverySearchComponent implements OnInit, OnDestroy {

  public vehicleCtrl: FormControl = new FormControl();
  public vehicleFilterCtrl: FormControl = new FormControl();
  public clientCtrl: FormControl = new FormControl();
  public clientFilterCtrl: FormControl = new FormControl();

  public filteredVehicles: ReplaySubject<ComboDto[]> = new ReplaySubject<ComboDto[]>(1);
  public filteredClients: ReplaySubject<ComboDto[]> = new ReplaySubject<ComboDto[]>(1);

  private _onDestroy = new Subject<void>();
  @ViewChild('vehicleSelect') vehicleSelect: MatSelect;
  @ViewChild('clientSelect') clientSelect: MatSelect;
  version = VERSION;

  @Input() showAdd: boolean;
  @Input() showPrint: boolean;
  @Input() showStatus: boolean;
  @Input() showShipDetail: boolean;
  @Input() firstValue: string = 'GENERAL.LABELS.ALL';
  @Output() onSearchEmitter: EventEmitter<DeliverySearch> = new EventEmitter<DeliverySearch>();
  @Output() onPrintEmitter: EventEmitter<DeliverySearch> = new EventEmitter<DeliverySearch>();
  

  search: DeliverySearch;
  vehicleList: Array<ComboDto> = new Array<ComboDto>();
  statusList: Array<ComboDto> = new Array<ComboDto>();
  clientList: Array<ComboDto> = new Array<ComboDto>();
  shipDetailList: Array<ComboDto> = new Array<ComboDto>();
  truck: any = '0';
  colNumber: number = 3;

  ShipStatusEnum = ShipStatusEnum;
  ShipDetailEnum = ShipDetailEnum;

  constructor(private apiService: ApiService) { }

  ngOnInit(): void {
    this.initSearch();
    this.getTrucks();
    //this.getClients();

    if (!this.showAdd) {
      this.colNumber = 4;
    }

    this.vehicleFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterVehicles();
      });
/*
    this.clientFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterClients();
      });*/
  }


  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  private filterVehicles() {
    if (!this.vehicleList) {
      return;
    }
    let search = this.vehicleFilterCtrl.value;
    if (!search) {
      this.filteredVehicles.next(this.vehicleList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredVehicles.next(
      this.vehicleList.filter(v => v.text.toLowerCase().indexOf(search) > -1)
    );
  }

  private filterClients() {
    if (!this.clientList) {
      return;
    }
    let search = this.clientFilterCtrl.value;
    if (!search) {
      this.filteredClients.next(this.clientList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredClients.next(
      this.clientList.filter(c => c.text.toLowerCase().indexOf(search) > -1)
    );
  }

  private initSearch() {
    this.vehicleList.push(new ComboDto(0, this.firstValue));
    //this.clientList.push(new ComboDto(0, this.firstValue));
    this.getStatus();
    this.getShipDetail();
    this.search = new DeliverySearch(new Date(), new Date(), 0, -1, undefined, [ShipDetailEnum.LOADED, ShipDetailEnum.WAREHOUSE]);
  }

  private getTrucks() {
    this.apiService.get<ComboDto[]>('api/Vehicle/getVehicleCombo').subscribe((response: ComboDto[]) => {
      if (response) {
        this.vehicleList = this.vehicleList.concat(response);
        this.filteredVehicles.next(this.vehicleList.slice());
        this.filteredVehicles
          .pipe(take(1), takeUntil(this._onDestroy))
          .subscribe(() => {
            this.vehicleSelect.compareWith = (a: ComboDto, b: ComboDto) => a.value === b.value;
          });
      }
    });
  }

  getClients(): any {
    this.apiService.get<ComboDto[]>('api/Client/getClientCombo').subscribe((response: ComboDto[]) => {
      if (response) {
        this.clientList = this.clientList.concat(response);
        this.filteredClients.next(this.clientList.slice());
        this.filteredClients
          .pipe(take(1), takeUntil(this._onDestroy))
          .subscribe(() => {
            this.clientSelect.compareWith = (a: ComboDto, b: ComboDto) => a.value === b.value;
          });
      }
    });
  }

  private getStatus() {
    this.statusList.push(new ComboDto(-1, 'GENERAL.LABELS.ALL'));

    for (let e in ShipStatusEnum) {
      if (typeof this.ShipStatusEnum[e] === 'string') {
        this.statusList.push(new ComboDto(+e, 'GENERAL.ENUMS.SHIP_STATUS.' + this.ShipStatusEnum[e]));
      }
    }
  }

  private getShipDetail() {
    for (let e in this.ShipDetailEnum) {
      if (typeof this.ShipDetailEnum[e] === 'string') {
        this.shipDetailList.push(new ComboDto(+e, 'GENERAL.ENUMS.SHIP_DETAIL.' + this.ShipDetailEnum[e]));
      }
    }
  }

  public onSearch() {
    this.search.client = this.clientCtrl.value;
    if (this.vehicleCtrl.value)
      this.search.vehicle = this.vehicleCtrl.value.value;

    this.onSearchEmitter.emit(this.search);
  }

  onPrint(){
    this.search.client = this.clientCtrl.value;
    if (this.vehicleCtrl.value)
      this.search.vehicle = this.vehicleCtrl.value.value;

    this.onPrintEmitter.emit(this.search);
  }
}
